// import { Button } from "@mui/material";
// import axios from "axios";
// import { useFormik } from "formik";
// import React, { useEffect, useState } from "react";
// import "react-quill/dist/quill.snow.css";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import { baseUrl } from "../../../Config/baseUrl";
// import ReactQuill from "react-quill";
// import 'react-quill/dist/quill.snow.css';

// export default function AddCMS() {

//   const modules = {
//     toolbar: [
//       [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
//       [{ size: [] }],
//       ['bold', 'italic', 'underline', 'strike', 'blockquote'],
//       [{ 'list': 'ordered' }, { 'list': 'bullet' },
//       { 'indent': '-1' }, { 'indent': '+1' }],
//       ['link', 'image', 'video'],
//       ['clean']
//     ],
//     clipboard: {

//       matchVisual: false,
//     }
//   };

//   const { state } = useLocation();
//   const { type } = useParams();
//   const [data, setData] = useState([]);
//   const store = localStorage.getItem("store_id");
//   const navegate = useNavigate();
//   const getCMS = () => {
//     axios
//       .get(
//         `${baseUrl}/blog/change-page-content-api/?store_id=${store}&id=${state}`,
//         {
//           headers: {
//             Authorization: `Token ${localStorage.getItem("token")}`,
//             "Access-Control-Allow-Origin": "*",
//           },
//         }
//       )
//       .then((res) => {
//         console.log("RESPONSE ==== : ", res.data);
//         setData(res.data?.data);

//       })
//       .catch((err) => {
//         console.log("ERROR: ====", err);
//         toast.error(err.message);
//       });
//   };

//   useEffect(() => {
//     state && getCMS();
//   }, [state]);



//   const formik = useFormik({
//     initialValues: {
//       heading: data?.heading || "",
//       content: data?.content || "",
//       sub_heading: data?.sub_heading || "",
//     },
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       const reqbody = new FormData();
//       reqbody.append("store_id", localStorage.getItem("store_id"));
//       reqbody.append("heading", values.heading);
//       reqbody.append("sub_heading", values.sub_heading);
//       reqbody.append("content", values.content);
//       reqbody.append("page_id", 1);
//       type === "update" && reqbody.append("id", state);
//       type === "add"
//         ? axios
//           .post(
//             `${baseUrl}/blog/change-page-content-api/`,
//             { ...values, store: localStorage.getItem("store_id") },
//             {
//               headers: {
//                 Authorization: `Token ${localStorage.getItem("token")}`,
//                 "Content-Type": "multipart/form-data",
//               },
//             }
//           )
//           .then((response) => {
//             toast.success(response.data.message);
//             navegate("/cms");
//           })
//           .catch((error) => {
//             toast.error("Error adding blog:", error);
//           })
//         : axios
//           .patch(`${baseUrl}/blog/change-page-content-api/`, reqbody, {
//             headers: {
//               "Content-Type": "multipart/form-data",
//               Authorization: `Token ${localStorage.getItem("token")}`,
//             },
//           })
//           .then((response) => {
//             toast.success(response.data.message);
//             navegate("/cms");
//           })
//           .catch((error) => {
//             console.error("Error adding blog:", error);
//           });
//     },
//   });

//   return (
//     <div className="flex flex-col justify-center gap-5 py-4 ">

//       <div className="flex flex-col justify-center w-full lg:w-[70%]">
//         <div className="mt-5 bg-white shadow-lg">
//           <form onSubmit={formik.handleSubmit}>
//             <div className="p-2 border-gray-300 rounded-md ">
//               <div className="flex flex-col gap-5">
//                 <div className="w-full pl-3 ">
//                   <div>
//                     <p className="p-1 text-sm font-semibold">Heading</p>
//                     <input
//                       id="heading"
//                       placeholder="Enter Heading"
//                       value={formik.values.heading}
//                       className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                       onChange={formik.handleChange}
//                     />
//                   </div>
//                 </div>
//                 <div className="w-full pl-3 ">
//                   <div>
//                     <p className="p-1 text-sm font-semibold">Sub Heading</p>
//                     <input
//                       id="sub_heading"
//                       placeholder="Enter Sub Heading"
//                       value={formik.values.sub_heading}
//                       className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                       onChange={formik.handleChange}
//                     />
//                   </div>
//                 </div>
//                 <div className="w-full pl-3 ">
//                   <div>
//                     <p className="p-1 text-sm font-semibold">Content</p>
//                     {/* <input
//                       id="content"
//                       rows="5"
//                       placeholder="Enter Content"
//                       value={formik.values.content}
//                       className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                       onChange={formik.handleChange}
//                     /> */}
//                   </div>
//                 </div>


//               </div>
//             </div>

//             <ReactQuill
//               className="h-[25rem]"
//               id="content"
//               theme='snow'
//               value={formik.values.content}
//               onChange={(value) => formik.setFieldValue("content", value)}
//               formats={['header', 'font', 'size', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image', 'video']}
//               placeholder="Write something amazing..."
//               modules={modules}
//             />
//             <div className="w-full pl-3 ">
//               <Button type="submit" variant="contained">
//                 Submit
//               </Button>
//             </div>
//           </form>
//         </div>

//       </div>



//     </div>
//   );
// }


import { Button, TextField } from "@mui/material";
import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../../Config/baseUrl";
import 'react-quill/dist/quill.snow.css';
import * as Yup from "yup";
import ReactQuill from "react-quill";
import RichTextEditorCustom from "../../../Shared/CustomRichTextEditor";

// Optional reusable error display component
const ErrorText = ({ error }) =>
  error ? <div className="text-red-600 text-sm mt-1">{error}</div> : null;

export default function AddCMS() {
  const { state } = useLocation();
  const { type } = useParams();
  const store = localStorage.getItem("store_id");
  const navigate = useNavigate();

  const [data, setData] = useState({});

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    content: Yup.array().of(
      Yup.object().shape({
        sub_heading: Yup.string().required("Section heading is required"),
        content: Yup.string().required("Section content is required"),
      })
    ),
  });

  const getCMS = async () => {
    try {
      const res = await axios.get(
        `${baseUrl}/blog/content-writer-api/?store_id=${store}&content_id=${state}`,
        {
          headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res?.data?.response_code === 200) {
        setData(res.data?.data);
      } else {
        toast.info(res?.data?.message);
      }
    } catch (err) {
      toast.error(err.message || "Error loading CMS");
    }
  };

  useEffect(() => {
    if (state) getCMS();
  }, [state]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: data?.title || "",
      content: data?.content
        ? Object.entries(data.content).map(([sub_heading, content]) => ({
          sub_heading,
          content,
        }))
        : [{ sub_heading: "", content: "" }],
    },
    validationSchema,
    // onSubmit: (values) => {
    //   const contentMap = {};
    //   for (let sec of values.content) {
    //     if (sec.sub_heading.trim()) {
    //       contentMap[sec.sub_heading] = sec.content || "";
    //     }
    //   }

    //   const payload = {
    //     title: values.title,
    //     store: store,
    //     content: contentMap,
    //     ...(type === "update" ? { content_id: state } : {}),
    //   };

    //   const url = `${baseUrl}/blog/content-writer-api/`;
    //   const method = type === "update" ? axios.patch : axios.post;

    //   method(url, payload, {
    //     headers: {
    //       Authorization: `Token ${localStorage.getItem("token")}`,
    //       "Content-Type": "application/json",
    //     },
    //   })
    //     .then((res) => {
    //       toast.success(res.data.message || "Success");
    //       navigate("/cms");
    //     })
    //     .catch(() => {
    //       toast.error("Error submitting CMS");
    //     });
    // },

    onSubmit: (values) => {
      const contentArray = values.content.map((sec, index) => ({
        id: index + 1,
        title: sec.sub_heading,
        containt: sec.content,
      }));

      const payload = {
        title: values.title,
        store: store,
        content: contentArray,
        ...(type === "update" ? { content_id: state } : {}),
      };

      const url = `${baseUrl}/blog/content-writer-api/`;
      const method = type === "update" ? axios.patch : axios.post;

      method(url, payload, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          toast.success(res.data.message || "Success");
          navigate("/cms");
        })
        .catch(() => {
          toast.error("Error submitting CMS");
        });
    }

  });

  // const modules = {
  //   toolbar: [
  //     [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
  //     [{ size: [] }],
  //     ['bold', 'italic', 'underline', 'strike', 'blockquote'],
  //     [{ 'list': 'ordered' }, { 'list': 'bullet' },
  //     { 'indent': '-1' }, { 'indent': '+1' }],
  //     ['link', 'image', 'video'],
  //     ['clean']
  //   ],
  //   clipboard: {

  //     matchVisual: false,
  //   }
  // };

  const modules = {
    toolbar: [
      [{ 'font': [] }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      ['blockquote', 'code-block'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      ['clean']
    ]
  };

  const formats = [
    'font', 'header',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'script',
    'blockquote', 'code-block',
    'list', 'bullet', 'indent',
    'direction', 'align',
    'link', 'image', 'video'
  ];


  return (
    <div className="flex flex-col justify-center gap-5 py-4">
      <div className="flex flex-col justify-center w-full lg:w-[70%]">
        <div className="mt-5 bg-white shadow-lg p-5 rounded">
          <form onSubmit={formik.handleSubmit}>
            {/* Title */}
            <div className="mb-4">
              <label className="block font-semibold mb-1">Title</label>
              <input
                type="text"
                name="title"
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="w-full p-2 border border-gray-300 rounded"
              />
              <ErrorText error={formik.touched.title && formik.errors.title} />
            </div>

            {/* Dynamic Content Sections */}
            {formik.values.content.map((sec, index) => (
              <div key={index} className="mb-6 border p-4 rounded bg-gray-50">
                {/* Sub Heading */}
                <label className="block font-semibold mb-1 capitalize">
                  {formik.values.title} Page Heading {index + 1}
                </label>
                <input
                  type="text"
                  name={`content[${index}].sub_heading`}
                  value={sec.sub_heading}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="w-full p-2 mb-1 border border-gray-300 rounded"
                />
                <ErrorText
                  error={
                    formik.touched.content?.[index]?.sub_heading &&
                    formik.errors.content?.[index]?.sub_heading
                  }
                />

                {/* Content */}
                <label className="block font-semibold mt-3 mb-1  capitalize">
                  {formik.values.title} Page {sec.sub_heading || "Section"}  Content
                </label>
                {/* <TextField
                  multiline
                  rows={4}
                  name={`content[${index}].content`}
                  value={sec.content}
                  onChange={(e) =>
                    formik.setFieldValue(
                      `content[${index}].content`,
                      e.target.value
                    )
                  }
                  onBlur={formik.handleBlur}
                  fullWidth
                  className="!mb-1"
                /> */}

                {/* <ReactQuill
                  className="h-full mb-3"
                  name={`content[${index}].content`}
                  value={sec.content}
                  theme='snow'

                  onChange={(value) =>
                    formik.setFieldValue(
                      `content[${index}].content`,
                      value
                    )
                  }


                  placeholder="Write something amazing..."
                  modules={modules}
                  formats={formats}
                /> */}

                <div className="w-full mb-3">

                  <RichTextEditorCustom
                    value={sec.content}
                    className="h-full mb-3"


                    onChange={(html) => formik.setFieldValue(
                      `content[${index}].content`,
                      html
                    )} />
                  <ErrorText
                    error={
                      formik.touched.content?.[index]?.content &&
                      formik.errors.content?.[index]?.content
                    }
                  />
                </div>

                {/* Remove Button */}
                {formik.values.content.length > 1 && (
                  <Button
                    variant="outlined"
                    color="error"
                    className="mt-2"
                    onClick={() => {
                      const updated = [...formik.values.content];
                      updated.splice(index, 1);
                      formik.setFieldValue("content", updated);
                    }}
                  >
                    Remove Section
                  </Button>
                )}
              </div>
            ))}

            {/* Add More Section */}
            <div className="mb-4">
              <Button
                variant="outlined"
                onClick={() =>
                  formik.setFieldValue("content", [
                    ...formik.values.content,
                    { sub_heading: "", content: "" },
                  ])
                }
              >
                + Add More Section
              </Button>
            </div>

            {/* Submit */}
            <div>
              <Button type="submit" variant="contained" color="primary">
                {type === "update" ? "Update" : "Submit"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
